export function startOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function appendNextMonth(months) {
  const last = months[months.length - 1];
  return [...months, new Date(last.getFullYear(), last.getMonth() + 1, 1)];
}
